var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('polygon',{class:[_vm.status, {active: _vm.active, blink: !_vm.$highlight }],attrs:{"points":_vm.polygonpoints,"id":_vm.eyemoveid},on:{"click":_vm.polygonSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }